import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import BlogsListContainer from './containers/blogs-list/blogs-list.container';
import EditBlogContainer from './containers/edit-blog/edit-blog.container';
/**
 * function BlogModule components
 */
export const BlogModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.BLOG_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.BLOG_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.BLOG_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={BlogsListContainer}
      />
      <Route
        path={(APP_ROUTES.BLOG_MODULE.CHILDREN as RouteConfig).NEW.FULL_PATH}
        component={EditBlogContainer}
      />
      <Route
        path={(APP_ROUTES.BLOG_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH}
        component={EditBlogContainer}
      />
    </>
  );
};
